import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from '../ui/Countdown';
import { Button } from '../ui/Button';
import { trackPixelEvent } from '../../lib/metaPixel';
export function FinalCTA() {
  return <section className="py-24 relative" data-id="element-51">
      <div className="container mx-auto px-4" data-id="element-52">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-53">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 flex items-center justify-center gap-2" data-id="element-54">
            <span aria-hidden="true" data-id="element-55">⏰</span> EL PRECIO CIERRA EN:
          </h2>
          <div className="mb-12" data-id="element-56">
            <Countdown data-id="element-57" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12" data-id="element-58">
          {/* Tier 1 Abbreviated */}
          <div className="p-6 rounded-2xl bg-slate-800/40 border border-white/10 flex flex-col justify-between" data-id="element-59">
            <div data-id="element-60">
              <h3 className="text-lg font-bold text-white mb-1 flex items-center gap-2" data-id="element-61">
                <span aria-hidden="true" data-id="element-62">😴</span> MEGAPACK BIOHACKING DEL SUEÑO
              </h3>
              <p className="text-slate-400 text-sm mb-4" data-id="element-63">
                6 Tomos + 6 Bonos · Sistema completo
              </p>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-64">
                <span className="text-slate-500 line-through text-sm" data-id="element-65">
                  $45.000
                </span>
                <span className="text-3xl font-display font-bold text-white" data-id="element-66">
                  $19.990{' '}
                  <span className="text-sm text-slate-400 font-sans" data-id="element-67">ARS</span>
                </span>
              </div>
            </div>
            <Button fullWidth variant="secondary" href="https://www.recursoclosethegap.shop/cart/51641668337959:1" onClick={() => trackPixelEvent('InitiateCheckout', {
            content_name: 'Megapack Biohacking del Sueño',
            value: 19990,
            currency: 'ARS'
          })} data-id="element-68">
              → QUIERO MI MEGAPACK
            </Button>
          </div>

          {/* Tier 2 Abbreviated */}
          <div className="p-6 rounded-2xl bg-gradient-to-b from-amber-900/20 to-slate-900/80 border border-amber-500/50 flex flex-col justify-between relative" data-id="element-69">
            <div data-id="element-70">
              <h3 className="text-lg font-bold text-white mb-1 flex items-center gap-2" data-id="element-71">
                <span aria-hidden="true" data-id="element-72">🚀</span> MEGAPACK + SISTEMA DE
                IMPLEMENTACIÓN AVANZADO <span aria-hidden="true" data-id="element-73">⭐</span>
              </h3>
              <p className="text-amber-400/80 text-sm mb-4" data-id="element-74">
                6 Tomos + 6 Bonos + Accelerator Premium
              </p>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-75">
                <span className="text-slate-500 line-through text-sm" data-id="element-76">
                  $75.000
                </span>
                <span className="text-3xl font-display font-bold text-white" data-id="element-77">
                  $27.990{' '}
                  <span className="text-sm text-slate-400 font-sans" data-id="element-78">ARS</span>
                </span>
              </div>
            </div>
            <Button fullWidth href="https://www.recursoclosethegap.shop/cart/51641671385383:1" onClick={() => trackPixelEvent('InitiateCheckout', {
            content_name: 'Megapack + Sistema de Implementación Avanzado',
            value: 27990,
            currency: 'ARS'
          })} data-id="element-79">
              → QUIERO EL MEGAPACK + SISTEMA AVANZADO
            </Button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-slate-400 font-medium" data-id="element-80">
          <span className="flex items-center gap-1" data-id="element-81">
            <span aria-hidden="true" data-id="element-82">🔒</span> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-83">
            <span aria-hidden="true" data-id="element-84">⚡</span> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1" data-id="element-85">
            <span aria-hidden="true" data-id="element-86">🛡️</span> Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-87">
            <span aria-hidden="true" data-id="element-88">💳</span> Mercado Pago | Tarjeta |
            Transferencia
          </span>
        </div>
      </div>
    </section>;
}